import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import classnames from 'classnames';
import SimpleThread from '../SimpleThread';
import s from './CardLayoutThread.scss';
const CardLayoutThread = (props)=>{
    return /*#__PURE__*/ React.createElement(SimpleThread, _extends({}, props, {
        className: classnames(s['card-layout'], props.className),
        commentBoxWrapperClassName: s['commentbox-wrapper'],
        threadStackClassName: s['thread-stack'],
        headerClassName: s['header'],
        scrollableClassName: s['scrollable'],
        replyIndentModifier: 0
    }));
};
CardLayoutThread.displayName = 'CardLayoutThread';
export default CardLayoutThread;
